import { z } from "@core/zod";

export const TextContentSchema = z.object(
  { kind: z.literal("text"), text: z.string() },
  {
    kind: "The content's kind, plain text.",
    text: "The memory's text, injected when a trigger fires.",
  },
);
